// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__37F5o","content":"LayoutSettings_content__Q0DCN"};